export enum BucketObjectType {
    Folder,
    File
}
